import React from 'react'

const Location = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.24999 10C7.24999 7.37665 9.37664 5.25 12 5.25C14.6233 5.25 16.75 7.37665 16.75 10C16.75 12.6234 14.6233 14.75 12 14.75C9.37664 14.75 7.24999 12.6234 7.24999 10ZM12 6.75C10.2051 6.75 8.74999 8.20507 8.74999 10C8.74999 11.7949 10.2051 13.25 12 13.25C13.7949 13.25 15.25 11.7949 15.25 10C15.25 8.20507 13.7949 6.75 12 6.75Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M3.52436 8.85685C3.87869 4.55824 7.47084 1.25 11.784 1.25H12.216C16.5292 1.25 20.1213 4.55824 20.4756 8.85685C20.666 11.166 19.9527 13.4589 18.486 15.2526L13.693 21.1144C12.818 22.1845 11.182 22.1845 10.307 21.1144L5.51396 15.2526C4.0473 13.4589 3.33402 11.166 3.52436 8.85685ZM11.784 2.75C8.25149 2.75 5.30948 5.45948 5.01929 8.98008C4.86087 10.9019 5.45452 12.8102 6.67518 14.3031L11.4682 20.1649C11.7431 20.501 12.2569 20.501 12.5318 20.1649L17.3248 14.3031C18.5455 12.8102 19.1391 10.9019 18.9807 8.98008C18.6905 5.45948 15.7485 2.75 12.216 2.75H11.784Z" />
    </svg>



)


export default Location
